export const placeholderDateFormat = 'DD/MM/yyyy';
export const placeholderDateTimeFormat = 'DD/MM/yyyy hh:mm';
export const placeholderTimeFormat = 'hh:mm';